import { HashRouter as Router, Routes, Route } from "react-router-dom";
import { Home } from "./Entities/Home";
import { Nefrosys } from "./Entities/pages/Nefrosys";
import { UNEFRO } from "./Entities/pages/UNEFRO";
import { CitaConfirmada } from "./Entities/Citas/CitaConfirmada";
import { Consulta } from "./Entities/Consulta/Consulta";
import { Laboratorios as ConsultaLabs } from "./Entities/Consulta/Laboratorios";
import { App as AppProd } from "./Entities/App";
import { Inicio } from "./Entities/Inicio";
import "rsuite/dist/rsuite.min.css";
import "@coreui/coreui/dist/css/coreui.min.css";
import "./App.css";
import { Pacientes } from "./Entities/Pacientes/Pacientes";
import { Expedientes } from "./Entities/Pacientes/Expedientes";
import { LaboratoriosView } from "./Entities/Pacientes/LaboratoriosView";
import { Citas } from "./Entities/Citas/Citas";
import { CitasMedicas } from "./Entities/Citas/CitasMedicas";
import { CitasProgramadas } from "./Entities/Citas/CitasProgramadas";
import { Horarios } from "./Entities/Catalogos/Horarios";
import { InicioHemodialisis } from "./Entities/Hemodialisis/InicioHemodialisis";
import { ConsumosSesion } from "./Entities/Hemodialisis/ConsumosSesion";
import { AsignaFiltro } from "./Entities/Hemodialisis/AsignaFiltro";
import { Inventario } from "./Entities/Catalogos/Inventario";
import { Insumos } from "./Entities/Catalogos/Insumos";
import { Enfermeria } from "./Entities/Catalogos/Enfermeria";
import { MaquinasDialisis } from "./Entities/Catalogos/MaquinasDialisis";
import { Medicos } from "./Entities/Catalogos/Medicos";
import { Tecnicos } from "./Entities/Catalogos/Tecnicos";
import { Servicios } from "./Entities/Catalogos/Servicios";
import { Usuarios } from "./Entities/Catalogos/Usuarios";
import { HojaEnfermeria } from "./Entities/HojaEnfermeria/HojaEnfermeria";
import { AccesoModulo } from "./Entities/AccesoModulo";
import { NotaMedica } from "./Entities/NotaMedica/NotaMedica";
import { HojaEnfermeriaView } from "./Entities/HojaEnfermeria/HojaEnfermeriaView";
import { NotaMedicaView } from "./Entities/NotaMedica/NotaMedicaView";
import { Laboratorios } from "./Entities/Catalogos/Laboratorios";
import { FirmaConsentimiento } from "./Entities/Consentimientos/FirmaConsentimiento";
import { AvisoPrivacidad } from "./Entities/Consentimientos/AvisoPrivacidad";
import { ConsentHemo } from "./Entities/Consentimientos/ConsentHemo";
import { AplicacionHierro } from "./Entities/Consentimientos/AplicacionHierro";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" Component={Nefrosys} />
        <Route path="/App/Home" Component={Home} />
        <Route path="/App/Home/AccesoModulo" Component={AccesoModulo} />
        <Route path="/App/Home/Citas" Component={Citas} />
        <Route path="/App/Home/CitasMedicas" Component={CitasMedicas} />
        <Route path="/App/Home/CitasProgramadas" Component={CitasProgramadas} />
        <Route
          path="/App/Home/CitasMedicas/Consulta/:idPaciente/:idServicio/:fecha/:hora"
          Component={Consulta}
        />
        <Route
          path="/App/Home/Laboratorios/:idPaciente/:paciente"
          Component={ConsultaLabs}
        />
        <Route path="/App/Home/Pacientes" Component={Pacientes} />
        <Route path="/App/Home/Expedientes" Component={Expedientes} />
        <Route path="/App/Home/LaboratoriosView" Component={LaboratoriosView} />
        <Route path="/App/Home/AsignaFiltro" Component={AsignaFiltro} />
        <Route path="/App/Home/Consulta" Component={Consulta} />
        <Route path="/App/Home/Medicos" Component={Medicos} />
        <Route path="/App/Home/Horarios" Component={Horarios} />
        <Route path="/App/Home/Insumos" Component={Insumos} />
        <Route path="/App/Home/Servicios" Component={Servicios} />
        <Route path="/App/Home/Enfermeria" Component={Enfermeria} />
        <Route path="/App/Home/Laboratorios" Component={Laboratorios} />
        <Route path="/App/Home/Tecnicos" Component={Tecnicos} />
        <Route path="/App/Home/Usuarios" Component={Usuarios} />
        <Route path="/App/Home/MaquinasDialisis" Component={MaquinasDialisis} />
        <Route path="/App/Home/FirmaConsentimiento/:documento" Component={FirmaConsentimiento} />
        <Route path="/App/Home/FirmaConsentimiento/AvisoPrivacidad/:idPaciente/:paciente" Component={AvisoPrivacidad} />
        <Route path="/App/Home/FirmaConsentimiento/ConsentHemo/:idPaciente/:paciente" Component={ConsentHemo} />
        <Route path="/App/Home/FirmaConsentimiento/AplicacionHierro/:idPaciente/:paciente" Component={AplicacionHierro} />
        <Route
          path="/App/Home/InicioHemodialisis"
          Component={InicioHemodialisis}
        />
        <Route path="/App/Home/ConsumosSesion" Component={ConsumosSesion} />
        <Route path="/App/Home/HojaEnfermeria" Component={HojaEnfermeria} />
        <Route
          path="/App/Home/HojaEnfermeriaView/:idSesion/:idPaciente"
          Component={HojaEnfermeriaView}
        />
        <Route path="/App/Home/Inventario" Component={Inventario} />
        <Route path="/App" Component={AppProd} />
        <Route path="/App/Inicio" Component={Inicio} />
        <Route path="/App/Inicio/Consulta" Component={Consulta} />
        <Route path="/UNEFRO" Component={UNEFRO} />
        <Route path="/CitaConfirmada/:id/:phone" Component={CitaConfirmada} />
        <Route path="/App/Home/NotaMedica" Component={NotaMedica} />
        <Route
          path="/App/Home/NotaMedicaView/:idSesion/:idPaciente"
          Component={NotaMedicaView}
        />
      </Routes>
    </Router>
  );
}

export default App;
